import React from 'react';

type TitleProps = {
    title: string;
    textSize?: string;
}

const Title = ({ title, textSize = 'text-2xl' }: TitleProps) => {
    return (
        <div className="flex items-center justify-between">
            <p style={{ fontFamily: "Din condensed", whiteSpace: "nowrap" }}  className={`mr-4 ${textSize}`}>{title}</p>
        </div>
    );
};

export default Title;